import React from 'react';
import { Checkbox } from './ui/checkbox';
import { cn } from '@/lib/utils';
import { ExternalLink } from 'lucide-react';
import {
  Globe,
  Video,
  Palette,
  TrendingUp,
  Linkedin,
  GraduationCap,
  Smartphone,
  FileText
} from 'lucide-react';

const iconMap = {
  Globe,
  Video,
  Palette,
  TrendingUp,
  Linkedin,
  GraduationCap,
  Smartphone,
  FileText
};

export const ServiceCard = ({ service, isSelected, onToggle }) => {
  const IconComponent = iconMap[service.icon];

  const handlePortfolioClick = (e) => {
    e.stopPropagation();
    if (service.portfolioUrl) {
      window.open(service.portfolioUrl, '_blank');
    }
  };

  return (
    <div
      onClick={() => onToggle(service.id)}
      className={cn(
        'group flex items-start gap-2.5 p-2.5 rounded-lg cursor-pointer transition-all duration-200',
        'border border-transparent hover:border-slate-200',
        isSelected
          ? 'bg-emerald-50 border-emerald-200 hover:border-emerald-300'
          : 'hover:bg-slate-50'
      )}
    >
      <Checkbox
        checked={isSelected}
        onCheckedChange={() => onToggle(service.id)}
        className={cn(
          'mt-0.5 transition-colors flex-shrink-0',
          isSelected && 'border-emerald-600 bg-emerald-600 text-white'
        )}
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5">
          {IconComponent && (
            <IconComponent
              className={cn(
                'h-3.5 w-3.5 flex-shrink-0 transition-colors',
                isSelected ? 'text-emerald-600' : 'text-slate-400 group-hover:text-slate-600'
              )}
            />
          )}
          <span
            className={cn(
              'text-xs font-medium transition-colors truncate',
              isSelected ? 'text-emerald-900' : 'text-slate-700'
            )}
          >
            {service.name}
          </span>
        </div>
        <div className="flex items-center gap-2 mt-1">
          <span
            className={cn(
              'inline-block text-[10px] px-1.5 py-0.5 rounded',
              isSelected
                ? 'bg-emerald-100 text-emerald-700'
                : 'bg-slate-100 text-slate-600'
            )}
          >
            {service.price}
          </span>
          {service.portfolioUrl && (
            <button
              onClick={handlePortfolioClick}
              className="inline-flex items-center gap-1 text-[10px] text-emerald-600 hover:text-emerald-700 hover:underline transition-colors"
            >
              <ExternalLink className="h-2.5 w-2.5" />
              Portfolio
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
